'use client';

import { useState, useEffect } from 'react';
import { fetchCars, fetchFilters, fetchPopularCars } from '../lib/data';
import { useLanguage } from '../contexts/LanguageContext';

export function useCarData(initialParams = {}) {
  const [carsData, setCarsData] = useState(null);
  const [filtersData, setFiltersData] = useState(null);
  const [popularCarsData, setPopularCarsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    const loadData = async () => {
      if (!language) return;
      
      setLoading(true);
      try {
        const [cars, filters, popularCars] = await Promise.all([
          fetchCars({
            lang: language,
            ...initialParams
          }),
          fetchFilters({ lang: language }),
          fetchPopularCars({ lang: language })
        ]);

        setCarsData(cars);
        setFiltersData(filters);
        setPopularCarsData(popularCars);
        setError(null);
      } catch (err) {
        console.error('Error fetching car data:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [language, JSON.stringify(initialParams)]);

  return { carsData, filtersData, popularCarsData, loading, error };
}
